import type { ListItem } from "../../components/List/List"
import { EEnableStatusType } from "../../Enum/EEnableStatusType"
import { TutorialEntity } from "../Tutorial/TutorialEntity"
import { MemoryClass } from "./MemoryClass"

export class TutorialMemory extends MemoryClass<TutorialEntity> {
  setList = (list: TutorialEntity[]) => {
    this.listData = list
  }

  protected cloneEntity(item: TutorialEntity): TutorialEntity {
    return new TutorialEntity({ ...item })
  }

  protected getItemId(item: TutorialEntity): number {
    return item.id
  }

  getListCards = () => this.listData.map((item, index) => this.getCard(item, index))

  getCard(item: TutorialEntity, index: number): ListItem {
    const enable = item.status === EEnableStatusType.Active

    return {
      id: item.id,
      isDisable: !enable,
      index,
      title: item.title,
      linkImage: "",
      dataFilter: [item.title, item.category],
      children: (
        <div className="p-3">
          <p className="text-xs font-black text-orange-600 uppercase">{item.category}</p>

          <p className="text-sm font-bold text-slate-900 mt-1">{item.title}</p>

          <p className="text-xs text-slate-500 mt-1">{enable ? "Ativo" : "Inativo"}</p>
        </div>
      ),
    }
  }
}
